module.exports = __webpack_public_path__ + "static/media/email-template.fa3a91cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/email-template.png
// module id = 1273
// module chunks = 0